module.exports = __webpack_public_path__ + "static/media/1950.cd409e2a.svg";